<template>
    <q-dialog v-model="alert" @input="(val) => $emit('input', val)">
      <q-card>
        <q-card-section>
          <div class="text-h6"><translate>DATA_IMPORT</translate></div>
        </q-card-section>

        <q-card-section class="q-pt-none">
            <translate>THE_HYDRO_NUMBER_WILL_BE_IMPORTED</translate>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
              color="primary"
              @click="() => this.confirmImport()"
              v-close-popup
            >
              <translate>OK</translate>
            </q-btn>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { messageBox } from 'jtech'

  @Component({
    name: 'ImportDataAlert',
    props: {
      alert: { type: Boolean, default: false }
    }
  })
class ImportDataAlert extends Vue {
    confirmImport () {
      messageBox.success(this.$gettext('DATA_IMPORTED_SUCCESSFULLY'))
      this.$emit('import-data')
    }
  }
export default ImportDataAlert

</script>

<style lang="stylus" scoped>

</style>
